module.exports = __webpack_public_path__ + "fonts/KrungthaiFastWeb-Italic.b2faeb4a.woff";